import React from 'react';
import { iconSizer } from "../../../../../icons2022/iconSizer";
import { ArchiveIcon16Solid } from "../../../../../icons2022/FileTypeArchiveIcon/ArchiveIcon16Solid";
import { ArchiveIcon20Solid } from "../../../../../icons2022/FileTypeArchiveIcon/ArchiveIcon20Solid";
import { ArchiveIcon24Solid } from "../../../../../icons2022/FileTypeArchiveIcon/ArchiveIcon24Solid";
export var ArchiveIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(ArchiveIcon16Solid, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(ArchiveIcon20Solid, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(ArchiveIcon24Solid, null);
  }
}, 'ArchiveIcon');